if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          buttons: this.querySelectorAll('[id^="GalleryBtns"]')
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        this.activeIndex = 0
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));


        // ===== 移动端滑动 → 同步缩略图（不影响桌面功能）=====
        if (!this.mql.matches) {                    // 视口 < 750px
          const slides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
          const io = new IntersectionObserver(this.handleSlideIntersect.bind(this), {
            root: this.elements.viewer,
            threshold: 0.85                         // 60% 可见即视为当前
          });
          slides.forEach(s => io.observe(s));
        }



        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, index));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.elements.buttons[0].addEventListener('click', () => {
          const newActiveIndex = this.activeIndex - 1;
          if (newActiveIndex >= 0) {
            this.getVisibleThumbnailsItems()[newActiveIndex]?.querySelector('button').click();
          }
        });
        this.elements.buttons[1].addEventListener('click', () => {
          const newActiveIndex = this.activeIndex + 1;
          if (newActiveIndex < this.getVisibleThumbnailsItems().length) {
            this.getVisibleThumbnailsItems()[newActiveIndex]?.querySelector('button').click();
          }
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
      getVisibleThumbnailsItems(){
        return Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).filter((node)=>{
          return window.getComputedStyle(node).display !== 'none'
        })
      }

      setActiveThumbnail(thumbnail) {
        const visibleItems = this.getVisibleThumbnailsItems();
        const matchedIndex = visibleItems.findIndex((node) => node === thumbnail);
        if (matchedIndex !== -1) {
          this.activeIndex = matchedIndex;
        }

        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        const nextVisibleThumbnail = (() => {
          let next = thumbnail.nextElementSibling;
          while (next && window.getComputedStyle(next).display === 'none') {
            next = next.nextElementSibling;
          }
          return next;
        })();

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          if (nextVisibleThumbnail && !this.elements.thumbnails.isSlideVisible(nextVisibleThumbnail, 10)) {
            this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
            this.activeIndex = matchedIndex; // 保持当前真实索引
          }
          return;
        }

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        this.activeIndex = matchedIndex; // 保持当前真实索引
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
      /* ---------- 移动端 IntersectionObserver 回调（带 0.5 s 延迟） ---------- */
      handleSlideIntersect(entries) {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;          // 只处理正在视口里的那张

          // —— 取消上一次等待 ——  
          clearTimeout(this._ioTimer);

          // —— 0.5 s 后再真正同步缩略图 ——  
          this._ioTimer = setTimeout(() => {
            const mediaId = entry.target.dataset.mediaId;
            const thumb   = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (thumb) this.setActiveThumbnail(thumb);
          }, 50); // 500 ms
        });
      }

    }
  );
}
